import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.04289 9.20698C4.43342 9.59751 5.06658 9.59751 5.45711 9.20698C5.84763 8.81646 5.84763 8.18329 5.45711 7.79277L2.66427 4.99994L5.45711 2.20711C5.84763 1.81658 5.84763 1.18342 5.45711 0.792893C5.06658 0.402369 4.43342 0.402369 4.04289 0.792893L0.542954 4.29283C0.15243 4.68336 0.15243 5.31652 0.542954 5.70704L4.04289 9.20698Z"
        fill="#8E8E8E"
      />
    </svg>
  );
};

export default Svg;
